import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, UserCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import type { MatchedCandidate } from "@/types/inbox";

/** CRM candidate matched to the conversation counterpart. */
export const MatchedCandidateCard: React.FC<{ candidate: MatchedCandidate }> = ({ candidate }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<div className="rounded-sm border border-border bg-card p-3 shadow-card">
			<div className="flex items-center gap-2">
				<UserCheck className="h-4 w-4 shrink-0 text-primary" />
				<span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
					{t("inbox.context.matchedCandidate", "Matched candidate")}
				</span>
				<Badge variant="success" className="ml-auto">
					{t("inbox.context.inCrm", "In CRM")}
				</Badge>
			</div>
			<p className="mt-2 truncate text-sm font-semibold text-foreground">{candidate.name}</p>
			{candidate.function && (
				<p className="truncate text-xs text-muted-foreground">{candidate.function}</p>
			)}
			{candidate.email && <p className="truncate text-xs text-muted-foreground">{candidate.email}</p>}
			<Button
				variant="outline"
				size="sm"
				className="mt-3 w-full gap-1.5"
				onClick={() => navigate(`/candidates/${candidate.id}`)}
			>
				{t("inbox.context.openCandidate", "Open candidate")}
				<ArrowUpRight className="h-3.5 w-3.5" />
			</Button>
		</div>
	);
};
